import { Input } from '@ibsys/kit';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CLIENT_NAME_PARTS, type RecordPropertyValueName, type RecordValueSetForm } from '../model/recordValueSet';

type Props = {
  /** Имя поля значения в форме набора */
  name: RecordPropertyValueName;
  disabled: boolean;
};

/** Ввод клиента в строке набора значений: по полю на каждую часть имени из {@link CLIENT_NAME_PARTS} */
export const RecordClientField: FC<Props> = ({ name, disabled }) => {
  const { t } = useTranslation(['records']);
  const { control } = useFormContext<RecordValueSetForm>();

  return (
    <div className="flex flex-col gap-2 sm:flex-row">
      {CLIENT_NAME_PARTS.map((part) => (
        <Input
          key={part}
          control={control}
          name={`${name}.${part}`}
          placeholder={t(`records:valueSet.clientName.${part}`)}
          disabled={disabled}
          className="w-full sm:w-40"
        />
      ))}
    </div>
  );
};
